function _jade_template_fn(locals) {
  locals = locals || {};
  var h = require("panel").h;
  return h("div", {
    "class": {
      'calendar': true
    },
  })
}
module.exports = _jade_template_fn;